import {Component} from '@angular/core';
import {password} from "../../../../shared/constants/validation.constants";
import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {CommonService} from "../../../../shared/services/common.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {SetPasswordRequest} from "../../../core/authentication.actions";

@Component({
  selector: 'app-set-password-right-panel',
  templateUrl: './set-password-right-panel.component.html',
  styleUrls: ['./set-password-right-panel.component.css']
})
export class SetPasswordRightPanelComponent {


  errorMessages: any = {};
  errorMessageMap = {
    password: {
      required: 'This field is required.',
      minlength: `Password must contain at least ${password.length.min} characters`,
      maxlength: `Password must contain only ${password.length.max} characters`,
      lowerCaseCheckFailed: 'Password must contain at least 1 Lowercase character',
      upperCaseCheckFailed: 'Password must contain at least 1 Uppercase character',
      numberCheckFailed: 'Password must contain at least 1 numeric character',
      specialCharCheckFailed: 'Password must contain a Special character',
    },
    confirmPassword: {
      required: 'This field is required.',
      passwordMatchFailed: 'Passwords do NOT match..'
    }
  }

  form = new FormGroup({
    password: new FormControl('', {
      validators: [
        Validators.required,
        Validators.minLength(password.length.min),
        Validators.maxLength(password.length.max),
        this.commonService.validatePassword
      ],
    }),
    confirmPassword: new FormControl('', {
      validators: [
        Validators.required,
      ],
    })
  }, {validators: [this.validateConfirmPassword]});

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
  ) {
  }


  resetPassword() {
    if (this.form.invalid) {
      this.checkForErrors()
      return
    }
    const {password, confirmPassword} = this.form.getRawValue();
    const payload = {
      password,
      confirmPassword
    };
    this.store.dispatch(SetPasswordRequest({payload}))
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  validateConfirmPassword(control: AbstractControl): ValidationErrors | null {
    if (control && control.get('password') && control.get('confirmPassword')) {
      const password = control.get('password').value;
      const confirmPassword = control.get('confirmPassword').value;

      if (password && confirmPassword && password !== confirmPassword) {
        control.get('confirmPassword').setErrors({
          ...(control.get('confirmPassword').errors ? control.get('confirmPassword').errors : {}),
          passwordMatchFailed: true
        })
      }
    }
    return null;
  }
}
